export const FlagsmithFlags = {
  NextYearOrdering: 'next_year_ordering',
  NextYearQuoting: 'next_year_quoting',
  SalesForecastSeason: 'sales_forecast_season',
  DealerReportsExport: 'dealer_reports_export',
  MaintenanceMode: 'maintenance_mode',
  BusinessPlanRefactor: 'business_plan_refactor',
  // TODO - BECS-722 - Remove this feature flag once splits is live and stable
  Splits: 'splits',
  // TODO - BECS-803 - Remove this feature flag once marketing_requests is live and stable
  MarketingRequests: 'marketing_requests',
  ProductManagement: 'product_management',
  ScheduledMaintenance: 'scheduled_maintenance',
  ProductMidTierProgram: 'product_mid_tier_program',
  // TODO - Remove this feature flag once full farm is live and stable
  FullFarm: 'full_farm',
  // TODO - BECS-1838 - Remove this feature flag once limited_supply_on_quotes is live and stable
  LimitedSupplyOnQuotes: 'limited_supply_on_quotes',
  // TODO - Remove this feature flag once custom mix quoting is live and stable
  CustomMixQuoting: 'custom_mix_quoting',
  // TODO - BECS-2085 - Remove this feature flag once commitment_rewards_packet_v2 is live and stable
  CommitmentRewardsPacketV2: 'commitment_rewards_packet_v2',
  // TODO - BECS-1411 - Remove this feature flag once auto-granting new districts is live and stable
  EnableAutoDsmAccessGrant: 'enable_auto_dsm_access_grant',
} as const;

export type FlagsmithFlags = (typeof FlagsmithFlags)[keyof typeof FlagsmithFlags];
